import React from 'react';

type SocialShareProps = {
  className?: string;
  title: string;
  link: string;
};

// eslint-disable-next-line react/prefer-stateless-function
export default class SocialShare extends React.Component<SocialShareProps> {
  render() {
    const link = encodeURIComponent(`${process.env.EXP_HOST}${this.props.link}`);
    const social = [
      {
        id: 'f-social',
        icon: 'ecs-font-icon-soc-facebook',
        label: 'Share on Facebook.',
        linkToOpen: `https://www.facebook.com/login.php?next=https%3A%2F%2Fwww.facebook.com%2Fsharer%2Fsharer.php%3Fu%3D${link}%26ret%3Dlogin&display=popup`
      },
      {
        id: 'x-social',
        icon: 'ecs-font-icon-soc-x',
        label: 'Share on X.',
        linkToOpen: `https://twitter.com/intent/tweet?url=${link}&text=${this.props.title}`
      },
      {
        id: 'in-social',
        icon: 'ecs-font-icon-soc-linkedin',
        label: 'Share on Linkedin.',
        linkToOpen: `https://www.linkedin.com/shareArticle?mini=true&url=${link}&title=${this.props.title}`
      }
    ];
    const share = (linkToOpen: string) => {
      window.open(
        linkToOpen,
        this.props.title,
        'width=600,height=400,resizable,scrollbars=yes,status=1'
      );
    };

    return (
      <ul className={`${this.props.className || ''} d-flex list-unstyled mb-0`}>
        {social.map((item) => (
          <li
            key={item.id}
            className="mb-0">
            <button
              type="button"
              className="btn-reset lh-1 pt-2 pe-2"
              aria-label={item.label}
              onClick={() => {
                share(item.linkToOpen);
              }}>
              <span
                className={`${item.icon} font-icon-size-md`}
                aria-hidden="true"
              />
            </button>
          </li>
        ))}
      </ul>
    );
  }
}
